import {
  BellOutlined,
  MenuOutlined,
  SettingOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar, Button, Dropdown, Flex, Menu, MenuProps, Space } from "antd";
import { useEffect, useState } from "react";
// Import useLocation from react-router-dom
import { getAuth } from "firebase/auth";
import { FiLogOut } from "react-icons/fi";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useToken } from "../../hooks/useToken";
import { useAI } from "../../providers/AIProvider";
import { useTheme } from "../../providers/ThemeProvider";
import { useAuth } from "../../providers/UserProvider";
import { getMediaFile } from "../../services/media.service";
import { getUserProfile } from "../../services/users.service";
import { ModalPostNew } from "../timeline/ModalPostNew";

export function Header() {
  const { user } = useAuth();
  const { token, screens } = useToken();
  const navigate = useNavigate();
  const [current, setCurrent] = useState<string>("");
  const { theme } = useTheme();
  const { isUsingAI, setUseAI } = useAI();
  const [isAddingNewEvent, setAddNewEvent] = useState<boolean>(false);

  const [avatarUrl, setAvatarUrl] = useState<string>();

  // Get the current location object
  const location = useLocation();
  // Extract the pathname
  const currentPath = location.pathname;

  useEffect(() => {
    getUserProfile({
      onSuccess: (data) => {
        if (data.avatar) {
          getMediaFile({
            mediaId: data.avatar,
            onSuccess: (data) => {
              setAvatarUrl(URL.createObjectURL(data));
            },
          });
        }
      },
    });
  }, [user.uid]);

  useEffect(() => {
    let pathname = currentPath; // Use currentPath from useLocation

    if (pathname === "/") {
      return setCurrent("dashboard");
    }
    // Remove leading slash for menu key matching
    setCurrent(pathname.replace("/", ""));
  }, [currentPath]); // Depend on currentPath from useLocation

  const onClick: MenuProps["onClick"] = (e) => {
    if (e.key === "dashboard") {
      return navigate(`/`);
    }
    navigate(`/${e.key}`);
  };

  return (
    <>
      {isAddingNewEvent && (
        <ModalPostNew
          onClose={() => setAddNewEvent(false)}
          onCreate={() => {
            setAddNewEvent(false);
          }}
        />
      )}

      <nav
        style={{
          backdropFilter: "blur(30px)",
          borderBottom: `${token.lineWidth}px ${token.lineType} ${token.colorSplit}`,
          position: "relative",
        }}
      >
        <div
          style={{
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            margin: "0 auto",
            maxWidth: "100%",
            padding: screens.md
              ? `0px ${token.paddingLG}px`
              : `0px ${token.padding}px`,
          }}
        >
          <div
            style={{
              alignItems: "center",
              display: "flex",
              gap: token.size,
              width: "100%",
            }}
          >
            {/* ... Logo and Menu ... */}
            <Link
              style={{
                display: "flex",
                alignItems: "center",
                height: "50px",
                left: "50%",
                position: screens.md ? "static" : "absolute",
                top: "50%",
                transform: screens.md ? " " : "translate(-50%, -50%)",
              }}
              to="/"
            >
              <img
                src={
                  theme == "DARK"
                    ? "/assets/logo_dark.png"
                    : "/assets/logo_white.png"
                }
                alt=""
                style={{
                  height: "36px",
                  objectFit: "contain",
                }}
              />
            </Link>
            <Menu
              style={{
                backgroundColor: "transparent",
                borderBottom: "none",
                lineHeight: screens.sm ? "4rem" : "3.5rem",
                marginLeft: screens.md ? "0px" : `-${token.size}px`,
                width: screens.md ? "inherit" : token.sizeXXL,
              }}
              mode="horizontal"
              items={[
                {
                  key: "dashboard",
                  label: "Dashboard",
                },
                {
                  key: "timeline",
                  label: "Timeline",
                },
              ]}
              onClick={onClick}
              // Use the current state derived from useLocation for selectedKeys
              selectedKeys={screens.md ? [current] : []}
              overflowedIndicator={
                <Button type="text" icon={<MenuOutlined />}></Button>
              }
            />
          </div>
          <Flex align="center" gap={token.marginXXL}>
            {screens.md &&
              currentPath === "/timeline" && ( // <-- Added check for '/timeline'
                <Flex
                  align="center"
                  gap={token.marginMD}
                  style={{
                    marginRight: "70px",
                  }}
                >
                  <Flex
                    className="gradient-border"
                    style={{ cursor: "pointer", padding: "2px" }}
                    onClick={() => setUseAI(!isUsingAI)}
                  >
                    <Button
                      style={{
                        width: "148px",
                      }}
                    >
                      Ask AI
                    </Button>
                  </Flex>
                  <Button
                    onClick={() => setAddNewEvent(true)}
                    style={{
                      width: "148px",
                    }}
                  >
                    Add New Event
                  </Button>
                </Flex>
              )}

            <Space>
              <BellOutlined
                style={{ color: token.colorText, fontSize: "16px" }}
              />

              <Dropdown
                overlayStyle={{ minWidth: "160px" }}
                menu={{
                  items: [
                    {
                      key: "settings",
                      label: "Settings",
                      icon: <SettingOutlined />,
                      onClick: () => navigate("/settings"),
                    },

                    {
                      type: "divider",
                    },
                    {
                      key: "logout",
                      label: "Logout",
                      icon: <FiLogOut />,
                      onClick: () => {
                        getAuth().signOut();
                      },
                    },
                  ],
                }}
                trigger={["click"]}
              >
                <Avatar
                  style={{
                    cursor: "pointer",
                  }}
                  icon={<UserOutlined />}
                  size={36}
                  src={avatarUrl}
                />
              </Dropdown>
            </Space>
          </Flex>
        </div>
      </nav>
    </>
  );
}
